import React from "react";
import PropTypes from "prop-types";
import Style from "./../../../../assets/scss/custom.module.scss";
import { useSelector } from "react-redux";
import FundedDatePicker from "../../../datepicker/FundedDatePicker";
import { fundedInvoicesData } from "../../../../locales/en";
export default function FundedTableHeader({
  tempSearchQuery,
  handleSearchChange,
  handleKeyDown,
  SearchText,
  selectedIds,
  selectedDate,
  earliestDueDateSelected,
  onDateChange,
  onNewDateChange,
  showUpdateButton
}) {
  const { fundedLoader } = useSelector((state) => state.invoice);

  return (
    <div className="sales-page-title-wrap sub-heading-blog-wrap pe-0 ps-0 mb-3">
      <div className="row box-heading">
        <div className="col-12 d-flex flex-wrap align-items-center justify-content-end">
          <ul
            className={`${Style.searchOptionWrap} d-flex flex-wrap align-items-center justify-content-md-end`}
          >
            {selectedIds.length > 1 && (
              <>
                <li className="funded-repay-dateinput">
                  <FundedDatePicker
                    key={selectedIds.join("-")}
                    selected={
                      selectedDate
                        ? new Date(selectedDate)
                        : earliestDueDateSelected
                    }
                    originalDueDate={earliestDueDateSelected}
                    onChange={onDateChange}
                  />
                </li>
                {showUpdateButton && (
                  <li>
                    <button
                      type="button"
                      className="btn-primary repayment-date-btn py-0 px-2"
                      onClick={onNewDateChange}
                    >
                      {fundedInvoicesData?.funded?.newDate}
                    </button>
                  </li>
                )}
              </>
            )}
            <li className="my-1">
              <div className="refferal-search-wrap">
                <div className="filtersearch mb-1 mt-1">
                  <span>
                    <input
                      type="search"
                      value={tempSearchQuery}
                      onChange={handleSearchChange}
                      placeholder={SearchText}
                      onKeyDown={handleKeyDown}
                      className="rounded-0"
                      disabled={fundedLoader}
                    />
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

FundedTableHeader.propTypes = {
  invoiceType: PropTypes.string,
  handleInvoiceTypeChange: PropTypes.func,
  tempSearchQuery: PropTypes.string,
  handleSearchChange: PropTypes.func,
  handleKeyDown: PropTypes.func,
  SearchText: PropTypes.string,
  selectedIds: PropTypes.array,
  selectedDate: PropTypes.string,
  earliestDueDateSelected: PropTypes.instanceOf(Date),
  onDateChange: PropTypes.func,
  onNewDateChange: PropTypes.func,
  showUpdateButton: PropTypes.bool
};
